import { useEffect } from 'react';
export const useUpdatePosition = ({ update }) => {
    useEffect(() => {
        const onScroll = () => update?.();
        document.addEventListener('scroll', onScroll);
        return () => document.removeEventListener('scroll', onScroll);
    }, [update]);
    useEffect(() => {
        update?.();
    }, [update]);
};
